// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/components/formatter/producprice.less
// module id = 1912
// module chunks = 0